import { Tile } from "./tile";

export class TileWithChildren extends Tile {
  children?: Tile[]

  static create(tileRaw: string | object): TileWithChildren {
    const newTile = new TileWithChildren();
    newTile.hydrate(tileRaw);
    return newTile;
  }
}
